
import { openShiftResponseApi } from '@/api';
import ActionDialog from '@/components/dialog/ActionDialog.vue';
import { showSuccess } from '@/plugins/ToastNotifications';
import OpenShiftResponseDetails from '@/views/schedule/dialogs/components/OpenShiftResponseDetails.vue';
import { PropType } from 'vue';
import { OpenShiftResponse, Shift } from '../../../../api/v1';
import { Icon } from '../../../lib/enum/Icon';

export default {
  name: 'WithdrawOpenShiftResponse',
  components: {
    OpenShiftResponseDetails,
    ActionDialog,
  },
  props: {
    value: {
      type: Boolean,
      required: true,
    },
    shift: {
      type: Object as PropType<Shift>,
      required: true,
    },
    openShiftResponse: {
      type: Object as PropType<OpenShiftResponse | undefined>,
      default: undefined,
    },
  },
  data() {
    return {
      Icon,
      timezone: this.$store.getters.timezone,
      detailsOpen: false,
    };
  },
  computed: {
    open: {
      get() {
        return this.value;
      },
      set(val: Boolean) {
        this.$emit('input', val);
      },
    },
  },
  methods: {
    async withdrawResponse() {
      // We're allowing undefined to be passed to the openShiftResponse prop given it won't exist once deleted
      // so add protection here
      if (!this.openShiftResponse) {
        return;
      }
      await openShiftResponseApi.deleteOpenShiftResponse({
        id: this.openShiftResponse.id,
      });

      showSuccess(this.$t('successMessage.openShiftResponseWithdrawn'));

      this.open = false;
    },
  },
};
